import React, { Component } from 'react';
import Modal from 'react-modal';
import styles from './Modal.module.css';

Modal.setAppElement('#modal');

const customStyles = {
  content: {
    top: '35%',
    left: '50%',
    width: '500px',
    right: 'auto',
    bottom: 'auto',
    border: '1px solid grey',
    padding: '20px',
    borderRadius: 0,
    transform: 'translate(-50%, -50%)',
  },
};

export default class ModalContainer extends Component {
  state = {
    error: null,
  };

  createTag = async () => {
    const { createTag, closeModal } = this.props;
    const tagName = this.refs['tagName'].value;
    const tag = await createTag(tagName);
    if (tag.status && tag.status === 'failed') {
      this.setState({ error: tag.message });
      return;
    }
    this.setState({ error: null });
    closeModal();
  };

  render() {
    const { error } = this.state;
    const { open, title, closeModal } = this.props;
    return (
      <Modal isOpen={open} style={customStyles}>
        <div className={styles.content}>
          <div className={styles.closeIcon} onClick={closeModal} />
          <div className={styles.header}>{title}</div>
          <div className={styles.inputTitle}>
            Tag Name*{' '}
            <span className={styles.required}>Required, must be unique</span>
          </div>
          <div className={styles.searchTagContainer}>
            <input
              ref="tagName"
              className={styles.searchTag}
              placeholder="Enter tag name here"
            />
            <button className={styles.upload} onClick={this.createTag}>
              Create Tag
            </button>
          </div>
          {error && <div className={styles.errorTxt}>{error}</div>}
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/index.js